<template>
    <v-container tag="section" class="mb-8">
        <v-row>
            <v-col class="py-sm-8 py-3">
                <h3 class="px-sm-9">{{ label }}</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col :sm="12 / socialFeeds.length" cols="12" class="py-sm-0" v-for="item in socialFeeds" :key="item.id">
                <v-card outlined tile flat class="twitter__feed">
                    <div class="d-flex flex-row twitter__header align-center">
                        <img :src="item[0].image" alt=""/>
                        <h4 v-html="item[0].title"></h4>
                    </div>
                    <div class="twitter__tweets">
                        <div v-for="(itemInner, index) in item" :key="itemInner.id">
                            <div v-if="index > 0">
                                <a :href="itemInner.href" class="twitter__wrapper" target="_blank">
                                    <v-card-text class="py-0" v-html="itemInner.body"></v-card-text>
                                    <v-card-subtitle class="pb-0 pt-1">{{ itemInner.date }}</v-card-subtitle>
                                </a>
                            </div>
                        </div>
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: [
            'label'
        ],
        // data() {
        //     return {
        //         SocialUpdates: [
        //             "<a class=\"twitter-timeline\" data-height=\"500\" href=\"https://twitter.com/minhealthnz?ref_src=twsrc%5Etfw\">Tweets by minhealthnz</a>",
        //             "<a class=\"twitter-timeline\" data-height=\"500\" href=\"https://twitter.com/WHO?ref_src=twsrc%5Etfw\">Tweets by WHO</a>"
        //         ]
        //     }
        // },
        // computed: {
        //     SocialUpdates() {
        //         return this.$store.state.client_vers.TWITTER
        //     }
        // },
        data() {
            return {
                socialFeeds: []
            }
        },
        mounted() {
            this.$axios.get(this.$store.state.client_vars.TWITTER)
                .then(response => {
                    this.socialFeeds = response.data
                })
                .catch(error => console.log('Failed to get client_vars', error))
        }
    }
</script>

<style lang="scss">
    .twitter__feed {

        .twitter__tweets {
            height: 500px;
            overflow: auto;
        }

        .twitter__header {
            padding: 13px;
            border-bottom: 1px solid #e1e2e3;

            * {
                margin-bottom: 0;
            }

            h4 {
                font-size: 16px;
            }
            
            img {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                flex: 0 0 50px;
                margin-right: 20px;
            }
        }

        .twitter__wrapper {
            display: block;
            text-decoration: none;
            color: var(--v-black-base);
            padding: 13px;
            transition: all .2s;
            border-bottom: 1px solid #e1e2e3;

            * {
                margin-bottom: 0;
            }

            img.Emoji {
                height: 20px!important;
            }

            &:hover {
                background-color: rgba(0, 0, 0, 0.26);
            }
        }
    }
</style>